"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _axios = _interopRequireDefault(require("axios"));
var _utils = require("@/utils");
var _moment = _interopRequireDefault(require("moment/moment"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      pageName: 'bailianReport',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        startTime: '',
        endTime: '',
        feedbackStartTime: '',
        feedbackEndTime: '',
        baiLianStoreName: '',
        storeBrand: '',
        empNo: '',
        empName: '',
        regionCode: [],
        cityCode: [],
        districtCode: []
      },
      form: {},
      region: [],
      regionOptions: []
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var endTime = _this.searchVal.endTime;
          if (endTime) {
            var maxDate = (0, _moment.default)(endTime, 'YYYY-MM-DD').toDate();
            var minDate = (0, _moment.default)(endTime, 'YYYY-MM-DD').subtract(90, 'days');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var startTime = _this.searchVal.startTime;
          if (startTime) {
            var minDate = (0, _moment.default)(startTime, 'YYYY-MM-DD').toDate();
            var maxDate = (0, _moment.default)(startTime, 'YYYY-MM-DD').add(90, 'days'); // 向后30天
            // const maxDate2 = moment() > maxDate ? maxDate : moment()
            if (timeGetTime < minDate || timeGetTime > maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    feedbackStartPickerOptions: function feedbackStartPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var feedbackEndTime = _this.searchVal.feedbackEndTime;
          if (feedbackEndTime) {
            var maxDate = (0, _moment.default)(feedbackEndTime, 'YYYY-MM-DD').toDate();
            var minDate = (0, _moment.default)(feedbackEndTime, 'YYYY-MM-DD').subtract(90, 'days');
            if (timeGetTime > maxDate || timeGetTime < minDate) {
              return true;
            }
          }
          return false;
        }
      };
    },
    feedbackEndPickerOptions: function feedbackEndPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          var timeGetTime = time.getTime();
          var feedbackStartTime = _this.searchVal.feedbackStartTime;
          if (feedbackStartTime) {
            var minDate = (0, _moment.default)(feedbackStartTime, 'YYYY-MM-DD').toDate();
            var maxDate = (0, _moment.default)(feedbackStartTime, 'YYYY-MM-DD').add(90, 'days'); // 向后30天
            // const maxDate2 = moment() > maxDate ? maxDate : moment()
            if (timeGetTime < minDate || timeGetTime > maxDate) {
              return true;
            }
          }
          return false;
        }
      };
    }
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    setTimeout(function () {
      // this.searchVal.startTime = moment().startOf('month').format('YYYY-MM-DD')
      // this.searchVal.endTime = moment().endOf('month').format('YYYY-MM-DD')
      _this2.fetchRegionList();
      _this2.searchData();
    }, 300);
  },
  methods: {
    fetchRegionList: function fetchRegionList() {
      var _this3 = this;
      if (this.$store.getters.regionData.length) {
        this.regionOptions = this.$store.getters.regionData;
        return;
      }
      this.$api.common.getRegionList(3).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this3.regionOptions = responseData.data;
          _this3.$store.dispatch('baseData/saveRegionData', responseData.data);
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    pcdClearEvent: function pcdClearEvent() {
      this.searchVal.regionCode = [];
      this.searchVal.cityCode = [];
      this.searchVal.districtCode = [];
    },
    pcdChangeEvent: function pcdChangeEvent(value) {
      console.log('=====val=====', value);
      var regionCodeArray = [];
      var cityCodeArray = [];
      var districtCodeArray = [];
      for (var i = 0; i < value.length; i++) {
        if (value[i].length === 3) {
          if (!regionCodeArray.includes(value[i][0])) {
            regionCodeArray.push(value[i][0]);
          }
          if (!cityCodeArray.includes(value[i][1])) {
            cityCodeArray.push(value[i][1]);
          }
          if (!districtCodeArray.includes(value[i][2])) {
            districtCodeArray.push(value[i][2]);
          }
        }
      }
      this.searchVal.regionCode = regionCodeArray;
      this.searchVal.cityCode = cityCodeArray;
      this.searchVal.districtCode = districtCodeArray;
    },
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchData: function fetchData() {
      var _this4 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      console.log(param);
      this.listLoading = true;
      this.$api.reportModule.getBailianList(param, this.sourceApi.token).then(function (res) {
        _this4.listLoading = false;
        _this4.list = res.data.items;
        _this4.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this4.listLoading = false;
      });
    },
    resetData: function resetData() {
      var _this5 = this;
      setTimeout(function () {
        _this5.region = [];
        _this5.searchVal.baiLianStoreName = '';
        _this5.searchVal.storeBrand = '';
        _this5.searchVal.empNo = '';
        _this5.searchVal.empName = '';
        _this5.searchVal.regionCode = [];
        _this5.searchVal.cityCode = [];
        _this5.searchVal.districtCode = [];
        _this5.searchVal.startTime = '';
        _this5.searchVal.endTime = '';
        _this5.searchVal.feedbackStartTime = '';
        _this5.searchVal.feedbackEndTime = '';
        _this5.searchData();
      }, 300);
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    downloadExcel: function downloadExcel() {
      var _this6 = this;
      // if (!this.searchVal.startTime || !this.searchVal.endTime) {
      //   this.$message.warning(this.$t('sfe.bailianReport.input.dataHolder'))
      //   return
      // }
      if (this.isLoading) return;
      this.isLoading = true;
      var fileName = this.$t('sfe.bailianReport.exportFileName');
      this.$api.reportModule.exportBailianList(this.searchVal).then(function (res) {
        _this6.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function (err) {
        _this6.$message.error(_this6.$t('sfe.bailianReport.input.exportFailed'));
        console.log(err);
        _this6.isLoading = false;
      });
    },
    downloadExcel2: function downloadExcel2() {
      var _this7 = this;
      // if (!this.searchVal.startTime || !this.searchVal.endTime) {
      //   this.$message.warning(this.$t('sfe.bailianReport.input.dataHolder'))
      //   return
      // }
      if (this.isLoading) return;
      this.isLoading = true;
      var fileName = this.$t('sfe.bailianReport.exportSumFileName');
      this.$api.reportModule.exportBailianSumList(this.searchVal).then(function (res) {
        _this7.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function (err) {
        _this7.$message.error(_this7.$t('sfe.bailianReport.input.exportFailed'));
        console.log(err);
        _this7.isLoading = false;
      });
    }
  }
};